import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "./Settings.scss";
import SettingsSidebar from "./SettingsSidebar";

const EmailSettings = () => {
  const [connectedAccounts, setConnectedAccounts] = useState([
    { provider: 'gmail', email: 'mein.account@gmail.com' },
    { provider: 'outlook', email: 'geschaeftlich@outlook.com' }
  ]);
  
  const [smtpConfig, setSmtpConfig] = useState({
    server: 'smtp.example.com',
    port: '587',
    username: '',
    password: '',
    encryption: 'tls'
  });

  const handleConnect = (provider: 'gmail' | 'outlook') => {
    // OAuth Integration hier einfügen
    const newAccount = {
      provider,
      email: `${provider}@connected.com` // Mock-Daten
    };
    setConnectedAccounts([...connectedAccounts, newAccount]);
  };

  const handleSMTPSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // SMTP Konfiguration speichern
    console.log('SMTP Config gespeichert:', smtpConfig);
  };

  return (
    <div className="settings-container">
  <SettingsSidebar />

      <div className="settings-content">
        <div className="email-settings-section">
          <h2>E-Mail-Konfiguration</h2>
          
          <div className="connected-accounts modern-card">
            <h3>Verbundene Konten</h3>
            <div className="account-grid">
              {connectedAccounts.map((account, index) => (
                <div key={index} className="account-card">
                  <div className={`provider-logo ${account.provider}`}>
                    {account.provider === 'gmail' ? 'G' : 'O'}
                  </div>
                  <div className="account-info">
                    <div className="email">{account.email}</div>
                    <div className="provider">{account.provider}</div>
                  </div>
                  <button className="disconnect-btn">Trennen</button>
                </div>
              ))}
            </div>
          </div>

          <div className="connection-options modern-card">
            <h3>Neues Konto verbinden</h3>
            <div className="oauth-buttons">
              <button 
                className="gmail-btn"
                onClick={() => handleConnect('gmail')}
              >
                <i className="fa-brands fa-google"></i>
                Mit Google verbinden
              </button>
              <button 
                className="outlook-btn"
                onClick={() => handleConnect('outlook')}
              >
                <i className="fa-solid fa-envelope"></i>
                Mit Outlook verbinden
              </button>
            </div>
          </div>

          <form className="smtp-form modern-card" onSubmit={handleSMTPSubmit}>
            <h3>Manuelle SMTP-Konfiguration</h3>
            
            <div className="form-grid">
              <div className="input-group">
                <label>SMTP Server</label>
                <input
                  type="text"
                  value={smtpConfig.server}
                  onChange={(e) => setSmtpConfig({...smtpConfig, server: e.target.value})}
                  required
                />
              </div>

              <div className="input-group">
                <label>Port</label>
                <input
                  type="number"
                  value={smtpConfig.port}
                  onChange={(e) => setSmtpConfig({...smtpConfig, port: e.target.value})}
                  required
                />
              </div>

              <div className="input-group">
                <label>Benutzername</label>
                <input
                  type="email"
                  value={smtpConfig.username}
                  onChange={(e) => setSmtpConfig({...smtpConfig, username: e.target.value})}
                  required
                />
              </div>

              <div className="input-group">
                <label>Passwort</label>
                <input
                  type="password"
                  value={smtpConfig.password}
                  onChange={(e) => setSmtpConfig({...smtpConfig, password: e.target.value})}
                  required
                />
              </div>

              <div className="input-group">
                <label>Verschlüsselung</label>
                <select
                  value={smtpConfig.encryption}
                  onChange={(e) => setSmtpConfig({...smtpConfig, encryption: e.target.value})}
                >
                  <option value="tls">TLS</option>
                  <option value="ssl">SSL</option>
                  <option value="none">Keine</option>
                </select>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="save-btn">
                Konfiguration speichern
              </button>
              <button type="button" className="test-btn">
                Verbindung testen
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailSettings;
